import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CertificateType } from "app/api/models";
import { EmailService, RepairsAndCalibrationsService } from "app/api/services";
import { AppLoaderService } from "app/core/services/app-loader/app-loader.service";
import { sendEmailPDF } from "app/views/calibrations/shared/helpers/email-sending-helper";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";
import { DragScrollModule } from "ngx-drag-scroll";
import { NgxPrintModule } from "ngx-print";

@Component({
  selector: "app-print-quotation-email-dialog",
  templateUrl: "./print-quotation-email-dialog.component.html",
  styleUrls: ["./print-quotation-email-dialog.component.scss", "./../../../../../_styles/calibration-overrides.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    FlexLayoutModule,
    DragScrollModule,
    NgxPrintModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
  ]
})
export class PrintQuotationEmailDialogComponent implements OnInit {
  formGroup: FormGroup;

  email: string;
  name: string;
  quote: string;
  currentUser: string;
  purchaseOrders: string[];
  blobPDFCertificate: Blob;
  loadcellId: number;

  constructor(
    public dialogRef: MatDialogRef<PrintQuotationEmailDialogComponent>,
    private emailService: EmailService,
    private repairsService: RepairsAndCalibrationsService,
    private loader: AppLoaderService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data != null) {
      (this.email = this.data?.email),
        (this.name = this.data?.name),
        (this.quote = this.data?.quote),
        (this.purchaseOrders = this.data?.purchaseOrders),
        (this.currentUser = this.data?.currentUser),
        (this.loadcellId = this.data?.loadcellId),
        (this.blobPDFCertificate = this.data?.blobPDFCertificate);
    }

    this.createFormControls();
  }

  public cancelEmailPDF(): void {
    this.dialogRef.close();
  }

  createFormControls() {
    this.formGroup = this.fb.group({
      emailToAddress: [this.email, Validators.required],
      subjectOfEmail: ["Quotation Certificate", Validators.required],
      emailBody: [
        `Good Morning/Afternoon ${this.name},\n\nThank you for sending your equipment to DLM for inspection and calibration.\n\nPlease see attached your quotation ${this.quote}.\n\nPlease note, ${this.quote} has been issued EXW. I am happy to quote return carriage if this is required.\n\nThank you also for your purchase order ${this.purchaseOrders}.\n\nKindly acknowledge receipt of the quote and please confirm the cost on your order will be updated by replying to this email.\n\nOnce processed the costs have been accepted please send a revised copy of your purchase order or a completed customer authorisation page. advise of any order number you wish to use to confirm you accept the costs.\n\nPlease also confirm your return delivery address.\n\nPlease also confirm if you will require either of the advisory repairs to be completed. and include advisory costs on your order where required.\n\nThere are no additional costs. The PO covers the cost of this quote. There is no further work required, so \nWork is complete \nWhere no repair is due\nThe calibration has been completed as part of the inspection process and we can dispatch the equipment \n\nprepare the equipment for collection \non receipt of your authorisation. \nto the address on your PO. \nWe can proceed as necessary on receipt of your authorisation and I will confirm once complete to request your collection details. \n\nPlease see attached a copy of the certificate of calibration. \nI will send copy documents once prepared. \nInvoice to follow. \n\nAlternatively you are welcome to arrange your own collection of the equipment, no carriage fee will apply.\nThe calibration is complete and you are welcome to collect any time. We are open 5 days a week, Mon – Fri, 8.30 – 5.00pm. Please send details of the collection and any labels you would like put on the package. \nYou will receive notification of the shipment and confirmation following delivery. \n\nconfirm once payment has been completed. Please complete payment via BACS or online banking. We can then proceed and arrange dispatch on receipt of payment. If possible please send a copy of your remittance. \n\nBest Regards,\n${this.currentUser}`,
        Validators.required,
      ],
    });
  }

  sendEmailPDF() {
    if (this.formGroup?.valid) {
      var blob = this.blobPDFCertificate;

      this.loader.open;
      sendEmailPDF(
        this.emailService,
        this.formGroup,
        this.loader,
        this.snack,
        blob,
        CertificateType.Quotation,
        this.loadcellId,
      );
      
      // add to loadcell email trail


      var quoteId = +this.quote.replace('R', '');
      this.repairsService.apiRepairsAndCalibrationsSetQuoteEmailedPost$Json$Response({quoteId: quoteId}).subscribe();
    }
  }
}
